export const GROUP_ADDABLE_MEMBER_FILTER = "group_addable:!=false";

export const createGroupAddableMemberFilter = ({ onlyUserId }: { onlyUserId?: string | null }) => {
  if (onlyUserId) {
    return `(creator_user_id:'${onlyUserId}' || ${GROUP_ADDABLE_MEMBER_FILTER})`;
  }

  return GROUP_ADDABLE_MEMBER_FILTER;
};
